import org.jetbrains.compose.web.renderComposable
import kotlinx.browser.window
import kotlinx.browser.document

fun main() {
    renderComposable(rootElementId = "root") {
        val hostname = window.location.hostname

        // Jednostavna logika rutiranja bazirana na hostname-u ili putanji
        if (hostname.contains("admin")) {
            document.title = "Šafran Admin"
            AdminApp()
        } else {
            document.title = "Šafran - Najbolji recepti"
            RecipeApp()
        }
    }
}
